<template>
  <div class="max-w-xl mx-auto py-10 px-4 text-center">
    <h1 class="text-2xl font-semibold mb-4">{{ $t('point.mismatch.title') }}</h1>
    <p class="mb-6">{{ $t('point.mismatch.description') }}</p>

    <div class="flex gap-3 justify-center">


        <router-link :to="{ name: 'points', params: { tourId: $store.getters['tours/activeTour'] }, query: { lang: $route.query.lang } }"
        :style="{
          backgroundColor: tourSettings.page_action_color,
          color: tourSettings.page_action_text_color
        }"
        :class="[
          'flex mx-auto my-5 py-2 px-6 rounded-full ',
        ]"
      >
        {{ $t('point.mismatch.choose_other_point') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PointMismatch',
  computed: {
    ...mapGetters('settings', ['tourSettings']),
  }

}
</script>



